import { usePOSStore } from '../stores/posStore';
import CartItem from '../components/CartItem';

export default function Cart(): JSX.Element {
  const cart = usePOSStore((state) => state.cart);
  const getCartTotal = usePOSStore((state) => state.getCartTotal);
  const clearCart = usePOSStore((state) => state.clearCart);

  if (cart.length === 0) {
    return (
      <div className="p-4 text-center">
        <div className="text-gray-500 text-lg">Your cart is empty</div>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Shopping Cart</h2>
      <div className="space-y-3">
        {cart.map((item) => (
          <CartItem key={item.productId} item={item} />
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="flex justify-between items-center mb-4">
          <span className="text-lg font-semibold">Total:</span>
          <span className="text-2xl font-bold text-blue-600">₦{getCartTotal().toFixed(2)}</span>
        </div>
        <button
          onClick={clearCart}
          className="w-full bg-red-600 text-white py-2 rounded font-medium hover:bg-red-700 transition-colors"
        >
          Clear Cart
        </button>
      </div>
    </div>
  );
}
